
import {Options, Vue} from 'vue-class-component';

@Options({
  props: ['items'],
  data() {
    console.log(this.items)
    return {
      item: this.items
    }
  },
  methods: {}
})

export default class MultiLevelSelectCard extends Vue {
}

